class FormsLabelType {
  Name() {
    return 0;
  }
  Family() {
    return 1;
  }
  FatherName() {
    return 2;
  }
  Gender() {
    return 3;
  }
  NationalCode() {
    return 4;
  }
  BirthDay() {
    return 5;
  }
  Mobile() {
    return 6;
  }
  Email() {
    return 7;
  }
  Phone() {
    return 8;
  }
  PostalCode() {
    return 9;
  }
  Address() {
    return 10;
  }
  CompanyName() {
    return 11;
  }
  Occupation() {
    return 12;
  }
  CodeNumber() {
    return 13;
  }
  CompanyNationalCode() {
    return 14;
  }
  CompanyAddress() {
    return 15;
  }
  RejectAuthNational() {
    return 16;
  }
  RejectAuthPostal() {
    return 17;
  }
  RejectAuthOther() {
    return 18;
  }
  CompanyEconomicCode() {
    return 19;
  }
  City() {
    return 20;
  }
  Province() {
    return 21;
  }
  Street(){
    return 22;
  }
  Alley(){
    return 23;
  }
  Plaque(){
    return 24;
  }
}
export default new FormsLabelType();
